import { TRANSLATION_LOCALES } from '../models/TranslationSchemas';

export const ADMIN_LANGUAGE_STORAGE_KEY = 'tiga.admin.response-language.v1';
export const DEFAULT_ADMIN_LANGUAGE = 'en';

const supportedLanguageCodes = new Set(
  TRANSLATION_LOCALES.map((locale) => locale.code)
);

const acceptLanguageValues = {
  'zh-hans': 'zh-Hans-CN',
  'zh-hant': 'zh-Hant-TW',
};

export const isSupportedAdminLanguage = (language) => (
  typeof language === 'string' && supportedLanguageCodes.has(language)
);

export const getAdminLanguage = () => {
  try {
    const storedLanguage = window.localStorage.getItem(ADMIN_LANGUAGE_STORAGE_KEY);
    if (isSupportedAdminLanguage(storedLanguage)) {
      return storedLanguage;
    }
  } catch (error) {
    // Storage can be unavailable under restrictive browser privacy settings.
  }

  return DEFAULT_ADMIN_LANGUAGE;
};

export const setAdminLanguage = (language) => {
  if (!isSupportedAdminLanguage(language)) {
    return false;
  }

  try {
    window.localStorage.setItem(ADMIN_LANGUAGE_STORAGE_KEY, language);
    return true;
  } catch (error) {
    return false;
  }
};

export const getAdminAcceptLanguage = () => {
  const language = getAdminLanguage();
  return acceptLanguageValues[language] || language;
};

export const isAdminPath = (pathname = window.location.pathname) => (
  pathname === '/admin' || pathname.startsWith('/admin/')
);
